import MdaeCheckBox from "./component";
import { ICheckBoxOptions } from "devextreme-react/check-box";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeChecBoxProps extends ICheckBoxOptions {
  id: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeCheckBox;
